import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Box, Card, CardContent, CardHeader } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { Page } from '@occc-app/design-system';

import { GeneralDetailsFormFields } from './components/general-details-form-fields.component';
import { validateGeneralDetailsForm } from './retailer-network-my-stores-store-v2-update-page.validation';
import {
  GeneralDetailsFormValues,
  GeneralDetailsFormInitialValues,
} from './retailer-network-my-stores-store-v2-update-page.types';

import { StoreBranding } from '../retailer-network-location-update-page/components/store-branding.component';
import { StoreSchedule } from '../retailer-network-location-update-page/components/store-schedule.component';
import { StoreAttributes } from '../retailer-network-location-update-page/components/store-attributes.component';

const PAGE_TITLE = 'Edit General Details';

type RetailerNetworkMyStoresStoreV2UpdatePageProps = {
  locationName: string;
  retailerNetworkUuid: string;
  initialValues: GeneralDetailsFormInitialValues;
  onSubmit: (values: GeneralDetailsFormValues) => void;
  goBack: () => void;
};

export const RetailerNetworkMyStoresStoreV2UpdatePage = ({
  locationName,
  retailerNetworkUuid,
  initialValues,
  onSubmit,
  goBack,
}: RetailerNetworkMyStoresStoreV2UpdatePageProps) => {
  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{ title: locationName || PAGE_TITLE }}
      containerProps={{ variant: 'md' }}
    >
      <Form<GeneralDetailsFormValues, GeneralDetailsFormInitialValues>
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validateGeneralDetailsForm}
        keepDirtyOnReinitialize
        mutators={{ ...arrayMutators }}
        render={({ handleSubmit, submitting, pristine, invalid }) => (
          <form onSubmit={handleSubmit}>
            <Card sx={{ mb: 3 }}>
              <CardHeader
                title={
                  <Typography variant='h6' component='h3'>
                    {PAGE_TITLE}
                  </Typography>
                }
              />
              <CardContent>
                <GeneralDetailsFormFields retailerNetworkUuid={retailerNetworkUuid} />
              </CardContent>
            </Card>

            <Card sx={{ mb: 3 }}>
              <CardHeader
                title={
                  <Typography variant='h6' component='h3'>
                    Store Configuration
                  </Typography>
                }
              />
              <CardContent>
                <Typography variant='body1' component='h4' gutterBottom>
                  Working Hours
                </Typography>
              </CardContent>

              <StoreSchedule />

              <CardContent>
                <StoreAttributes />
              </CardContent>
            </Card>

            <Card sx={{ mb: 3 }}>
              <CardHeader
                title={
                  <Typography variant='h6' component='h3'>
                    Store Branding
                  </Typography>
                }
              />
              <CardContent>
                <StoreBranding />
              </CardContent>
            </Card>

            <Box m={1} display='flex' justifyContent='flex-end' alignItems='flex-end' gap={2}>
              <Button color='primary' onClick={goBack}>
                Cancel
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSubmit}
                disabled={pristine || submitting || invalid}
              >
                Save
              </Button>
            </Box>
          </form>
        )}
      />
    </Page>
  );
};
